module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[104]347.564381c.woff2";